import type { DataTableColumn } from './types';

/**
 * Check if the input is a valid key.
 */
function checkIsValidKey(key: unknown): key is string | number {
    return (typeof key === 'string' && Boolean(key)) || typeof key === 'number';
}

/**
 * Default key extractor for DataTable items.
 * Use the id or key property of the item.
 */
export function defaultKeyExtractor<Item extends object>(item: Item) {
    if ('id' in item && checkIsValidKey(item.id)) {
        return item.id;
    }

    if ('key' in item && checkIsValidKey(item.key)) {
        return item.key;
    }

    throw new Error(
        'DataTable: items must have a valid "key" or "id" property, use `getKey` prop to provide a custom key extractor'
    );
}

/**
 * Get the data for a column from an item.
 */
export function getColumnData<Item extends object>(
    item: Item,
    column: DataTableColumn<Item>
): unknown {
    if (column.data) {
        return column.data(item);
    }

    return item[column.key];
}
